const allowedMobileProtocol = new Set<string>()
// onsite iOS and Android App deep links
allowedMobileProtocol.add('hconnectonsiteauthorization:')
allowedMobileProtocol.add('hconnectonsiteauthorizationqa:')
allowedMobileProtocol.add('hconnectonsiteauthorizationdev:')

// AEMMA mobile app links
allowedMobileProtocol.add('hconnectaemmaauthorization:')
allowedMobileProtocol.add('hconnectaemmaauthorizationqa:')
allowedMobileProtocol.add('hconnectaemmaauthorizationdev:')

const allowedRedirectUrls = new Set<string>()
// localhost development domains
allowedRedirectUrls.add('http://localhost')
allowedRedirectUrls.add('https://localhost')
allowedRedirectUrls.add('http://hconnect.digital')
allowedRedirectUrls.add('http://127.0.0.1')
allowedRedirectUrls.add('https://127.0.0.1')

// QA CDN
allowedRedirectUrls.add('https://hconnecthub-qa.azureedge.net')
allowedRedirectUrls.add('https://hconnectmanage-qa.azureedge.net')
allowedRedirectUrls.add('https://hconnecttmon-qa.azureedge.net')
allowedRedirectUrls.add('https://hconnecthcem-qa.azureedge.net')
allowedRedirectUrls.add('https://hconnectinsight-qa.azureedge.net')
allowedRedirectUrls.add('https://hconnectcockpit-qa.azureedge.net')
allowedRedirectUrls.add('https://hconnectpom-qa.azureedge.net')
allowedRedirectUrls.add('https://hconnecthproduce-qa.azureedge.net')
allowedRedirectUrls.add('https://hconnectslot-qa.azureedge.net')
allowedRedirectUrls.add('https://hconnectinvitation-qa.azureedge.net')
allowedRedirectUrls.add('https://hconnectmaintain-qa.azureedge.net')
allowedRedirectUrls.add('https://hconnectsettings-qa.azureedge.net')
allowedRedirectUrls.add(
  'https://ai-data-collector-app-dev.hdigital-dev-emea-001.internal.aks.hcag.dev'
)

// QA CDN storage
allowedRedirectUrls.add('https://hconnecthubqa.z6.web.core.windows.net')
allowedRedirectUrls.add('https://hconnectadminqa.z6.web.core.windows.net')
allowedRedirectUrls.add('https://hconnecttmonqa.z6.web.core.windows.net')
allowedRedirectUrls.add('https://hconnecthcemqa.z6.web.core.windows.net')
allowedRedirectUrls.add('https://hconnectinsight.z6.web.core.windows.net')
allowedRedirectUrls.add('https://hconnectcockpit.z6.web.core.windows.net')
allowedRedirectUrls.add('https://hconnectpom.z6.web.core.windows.net')
allowedRedirectUrls.add('https://hconnecthproduce.z6.web.core.windows.net')
allowedRedirectUrls.add('https://hconnectslotqa.z6.web.core.windows.net')
allowedRedirectUrls.add('https://hconnectinvitation.z6.web.core.windows.net')
allowedRedirectUrls.add('https://hconnectmaintain.z6.web.core.windows.net')
allowedRedirectUrls.add('https://hconnectsettings.z6.web.core.windows.net')

allowedRedirectUrls.add('https://grpsapdz3.grouphc.net')
allowedRedirectUrls.add('https://a65zwbsp5.accounts.ondemand.com')
allowedRedirectUrls.add('https://abpgr2x3e.accounts.ondemand.com')
// production domains
const domains = [
  'heidelbergcement.com',
  'heidelbergcement.ge',
  'hconnect.digital',
  'hproduce.digital',
  'hanson.com.au',
  'hymix.com.au',
  'concrete.hk',
  'mebin.nl',
  'interbeton.be',
  'cbr.be',
  'enci.nl',
  'gsm-granulats.fr',
  'unibeton.fr',
  'heidelbergmaterials.us',
  'heidelbergmaterials.ca',
  'heidelbergmaterials.dk',
  'heidelbergmaterials.se',
  'heidelbergmaterials.no',
  'heidelbergmaterials.de',
  'heidelbergmaterials.fr',
  'heidelbergmaterials.ro',
  'heidelbergmaterials.com',
  'pnq.com.au',
  'heidelbergmaterials.co.uk',
  'heidelbergmaterials.it',
  'heidelbergmaterials.bg',
  'heidelbergmaterials.ba',
  'heidelbergmaterials.pl',
  'heidelbergmaterials-benelux.com',
  'mqp.co.uk',
  'emea-sgwext-test.heidelbergcement.com',
  'grpsapdz3.grouphc.net',
  'a65zwbsp5.accounts.ondemand.com',
  'abpgr2x3e.accounts.ondemand.com',
  'sustainability.heidelbergmaterials.com',
  'hproduce-dev.hcag.dev',
  'hproduce.hcag.dev',
  'hanson.co.uk',
  'heidelbergmaterials.com.au',
  'alexfraser.com.au',
  'highqualityconcrete.com.au'
]

const allowedIdentityServerDomains = new Set<string>()

allowedIdentityServerDomains.add('heidelbergcement.com')

export const isValidIdentityServer = (url: null | URL): boolean => {
  if (!url || !url.hostname) {
    return false
  }

  if (process.env.NODE_ENV === 'development' && url.hostname === 'localhost') {
    return true
  }

  // TODO: extend the check
  for (const domain of allowedIdentityServerDomains) {
    if (url.hostname.endsWith(`.${domain}`) && url.protocol === 'https:') {
      return true
    }
  }
  return false
}

export const isValidRedirectUrl = (url: URL): boolean => {
  try {
    if (allowedMobileProtocol.has(url.protocol)) {
      return true
    }

    const baseUrl = `${url.protocol}//${url.hostname}`
    if (allowedRedirectUrls.has(baseUrl) && !url.pathname.includes('error')) {
      return true
    }

    for (const domain of domains) {
      if (url.hostname.endsWith(`.${domain}`) && url.protocol === 'https:') {
        return true
      }
    }
  } catch {
    console.error('Redirect URL is Invalid')
  }
  return false
}
